import { getNameValuesFromEnumNames } from '@/utils/helpers';
import { SelectBooleanItemType } from './types';
import { OrganType } from '@/api/apis/case';

export const YES_NO_OPTIONS: SelectBooleanItemType[] = [
  { value: true, name: 'Yes' },
  { value: false, name: 'No' },
];

export const EMPLOYEE_ORGAN_LIST_LEGACY = getNameValuesFromEnumNames(OrganType).filter(
  ({ value }) => value !== OrganType.Kidney,
);

export const EXTRA_SHIFTS_AMOUNT: Array<string> = Array.from({ length: 31 }, (_, i) => i.toString());
